import { useDispatch, useSelector } from "react-redux"
import ConfirmationPopup from "../../../../components/popup/confirmationpopup/ConfirmationPopup"
import { BUTTON_TYPE } from "../../../../components/button/constants"
import styles from "./RequestConsentModal.styles"
import { componentKey, setConsentRequestPaymentDrawer, setIsSelectAll, setNoOfConsentRequestInfoModal, setSelectAllOrSelectSelectedModal, setZeroRequestMessageModal } from "./RequestConsentModalSlice";
import Popup from "../../../../components/popup/Popup";
import Button from "../../../../components/button/Button";
import Label from "../../../../components/label/Label";
import Loadable from "../../../../components/loadable/Loadable";
import { REQUEST_CONSENT_LOADING_STATES } from "./constants";
import { getConsentCount, getConsentMatchFee, getConsentUpdate } from "./RequestConsentModalSaga";
import { useEffect } from "react";
import commonStyles from "../RecipientList.styles"
import useGarbageCollector from "../../../../../libs/garbagecollector/garbageCollectorHooks";
import PaymentDrawer from "../../../components/paymentdrawer/PaymentDrawer";
import { PLACE_OF_ORIGIN_FOR_PAYMENT } from "../../../components/paymentdrawer/constants";
import ManageFormsService from "../../../../../services/ManageFormsService";

export default function RequestConsentModal({
    isOpen = false,
    onCloseCb = () => { },
    selectedPayer = {},
    selectedRecipients = [],
    highlightedRecipient = {},
    onPaymentSuccessCb = () => { },
}) {

    useGarbageCollector(componentKey);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setSelectAllOrSelectSelectedModal(isOpen))
    }, [])

    const { loadingState, selectAllOrSelectSelectedModal, noOfConsentRequestInfoModal, consentRequestPaymentDrawer, consentRequestCountDetails, consentRequestFeesDetails, isSelectAll, zeroRequestMessageModal } = useSelector(state => state[componentKey]);

    return (
        <Loadable
            currentState={loadingState?.state}
            loadingStates={[REQUEST_CONSENT_LOADING_STATES.CONSENT_REQUEST_COUNT_LOADING]}
            isNewLoadable={true}
            preserveChildMount={true}
            messageMap={{}}
        >
            <ConfirmationPopup
                title=''
                bodyText='Request consent from all the recipients under the chosen payer or only selected recipients?'
                isOpen={selectAllOrSelectSelectedModal}
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        const data = { PayerID: selectedPayer?.PayerDetailId, RecipientIds: selectedRecipients?.length ? selectedRecipients.map(item => item.RecipentDetailId) : [highlightedRecipient?.RecipentDetailId], IsAllSelect: true }
                        dispatch(getConsentCount(data));
                        dispatch(setSelectAllOrSelectSelectedModal(false))
                        dispatch(setNoOfConsentRequestInfoModal(true));
                        dispatch(setIsSelectAll(true))
                    },
                    confirmationButtonText: "Request Consent From All Recipients",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => {
                        const data = { PayerID: selectedPayer.PayerDetailId, RecipientIds: selectedRecipients?.length ? selectedRecipients.map(item => item.RecipentDetailId) : [highlightedRecipient?.RecipentDetailId], IsAllSelect: false }
                        dispatch(getConsentCount(data))
                        dispatch(setSelectAllOrSelectSelectedModal(false))
                        dispatch(setNoOfConsentRequestInfoModal(true))
                        dispatch(setIsSelectAll(false))
                    },
                    onCloseCb: () => {
                        dispatch(setSelectAllOrSelectSelectedModal(false))
                        onCloseCb();
                    },
                    cancelButtonText: "Request Consent From Selected Recipients",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
                isClose={false}
                customStyle={styles.popup}
            />

            {noOfConsentRequestInfoModal && <Popup
                isPopupOpen={noOfConsentRequestInfoModal}
                title={"Consent Request Details"}
                onCloseCb={onCloseCb}
                childrenStyles={styles.popupBody}
            >
                <Loadable
                    currentState={loadingState.state}
                    loadingStates={[REQUEST_CONSENT_LOADING_STATES.CONSENT_MATCH_FEE_LOADING]}
                    isNewLoadable={true}
                    messageMap={{}}
                >
                    <div style={styles.consentRequestDetailsContaier}>
                        <div>
                            <div>
                                <Label>No. of Total Consents requested: {consentRequestCountDetails?.TotalConsentsRequested}</Label>
                            </div>

                            <div>
                                <Label>No. of Consents Already Requested: {consentRequestCountDetails?.ConsentsAlreadyRequested}</Label>
                            </div>

                            <div>
                                <Label>No. of New Consents Requested: {consentRequestCountDetails?.NewConsentsRequested}</Label>
                            </div>
                        </div>

                        <div>
                            <b>Note: Consent Requests will not be processed for Recipients without email addresses and TIN</b>
                        </div>

                        <div>
                            <p>Please click on <b>Proceed to complete the process, otherwise click on Cancel to return to the previous page.</b></p>
                        </div>

                        <div style={styles.btnContainer}>
                            <Button style={commonStyles.popupButton} onClickCb={() => {
                                if (consentRequestCountDetails?.NewConsentsRequested > 0) {
                                    dispatch(getConsentMatchFee({ count: consentRequestCountDetails?.NewConsentsRequested }))
                                } else {
                                    const data = { PayerID: selectedPayer?.PayerDetailId, RecipientIds: selectedRecipients?.length ? selectedRecipients.map(item => item.RecipentDetailId) : [highlightedRecipient?.RecipentDetailId], IsAllSelect: isSelectAll }
                                    dispatch(getConsentUpdate(data))
                                }
                            }}>Proceed</Button>
                            <Button onClickCb={onCloseCb} style={commonStyles.popupButton} type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}>Cancel</Button>
                        </div>
                    </div>
                </Loadable>
            </Popup>}

            {zeroRequestMessageModal && <Popup
                isPopupOpen={zeroRequestMessageModal}
                title={""}
                onCloseCb={onCloseCb}
                childrenStyles={styles.popupBody}
            >
                <div style={styles.consentRequestDetailsContaier}>
                    <p>You have 0 recipients to process your request</p>
                    <div style={styles.btnContainer}>
                        <Button style={commonStyles.popupButton} onClickCb={onCloseCb}>Ok</Button>
                    </div>
                </div>
            </Popup>}

            {consentRequestPaymentDrawer &&
                <PaymentDrawer
                    isOpen={consentRequestPaymentDrawer}
                    onCloseCb={() => {
                        dispatch(setConsentRequestPaymentDrawer(false)); 
                        onCloseCb();
                    }}
                    fees={consentRequestFeesDetails}
                    filingFeeLabel={`Consent Request Fee`}
                    calculatePrepaySalesTax={true}
                    calculateEstimatedTax={true}
                    paymentServiceFunctionCb={ManageFormsService.requestConsent}
                    onPaymentSuccessCb={onPaymentSuccessCb}
                    placeOfOriginforpayment={PLACE_OF_ORIGIN_FOR_PAYMENT.BULK_CONSENT_PAYMENT}
                    paymentServiceFunctionExtraParams={{
                        RecipientIds: selectedRecipients?.length ? selectedRecipients.map(item => item.RecipentDetailId) : [highlightedRecipient?.RecipentDetailId],
                        selectAll: isSelectAll,
                        isAccountant: "true",
                        PayerId: selectedPayer?.PayerDetailId,
                        payerId: selectedPayer?.PayerDetailId,
                    }}
                />
            }
        </Loadable>
    )
}